import React, { useState } from "react"
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  InputGroup,
  Alert,
  Spinner,
  Container,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { RegisterAction } from "../../pages/registration/registrationAction"
import "./registration.css"

const initialState = {
  fName: "",
  lName: "",
  branch: "",
  email: "",
  password: "",
  dob: "",
  phone: "",
  gender: "",
  address: "",
}
const RegistrationTable = () => {
  const [register, setRegister] = useState(initialState)
  const dispatch = useDispatch()
  const { AdminRegisterResponse, isLoading } = useSelector(
    (state) => state.Registration
  )
  const { user } = useSelector((state) => state.user)

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setRegister({ ...register, [name]: value })
  }
  const handleOnSubmit = (e) => {
    e.preventDefault()
    if (!register.email || !register.password) {
      alert("plz fill up all the input field")
    }

    dispatch(
      RegisterAction({
        ...register,
        addedBy: {
          adminId: user._id,
          adminName: `${user.fName} ${user.lName}`,
        },
      })
    )

    setRegister(initialState)
  }

  return (
    <Container className="registration">
      <Card className="p-5">
        {AdminRegisterResponse?.message && (
          <Alert
            variant={
              AdminRegisterResponse?.status === "success" ? "success" : "danger"
            }
          >
            {AdminRegisterResponse?.message}
          </Alert>
        )}

        {isLoading && <Spinner variant="primary" animation="border"></Spinner>}

        <h1 className="text-center mb-3">Admin User Registration</h1>
        <hr />
        <Form onSubmit={handleOnSubmit}>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="3">
              First Name
            </Form.Label>
            <Col>
              <Form.Control
                name="fName"
                onChange={handleOnChange}
                value={register.fName}
                type="text"
                placeholder="Enter First Name"
                required
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              Last Name
            </Form.Label>
            <Col>
              <Form.Control
                name="lName"
                onChange={handleOnChange}
                value={register.lName}
                type="text"
                placeholder="Enter Last Name"
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              Branch
            </Form.Label>
            <Col>
              <Form.Select
                onChange={handleOnChange}
                name="branch"
                value={register.branch}
                required
              >
                <option>-- Select a branch --</option>
                <option value="all">All</option>
                <option value="sydney">Sydney</option>
                <option value="canberra">Canberra</option>
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              DOB
            </Form.Label>
            <Col>
              <Form.Control
                name="dob"
                onChange={handleOnChange}
                value={register.dob}
                type="date"
                placeholder="Date Of Birth"
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              Email
            </Form.Label>
            <Col>
              <Form.Control
                name="email"
                onChange={handleOnChange}
                value={register.email}
                type="email"
                placeholder="Enter Email"
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              Password
            </Form.Label>

            <Col>
              <Form.Control
                name="password"
                onChange={handleOnChange}
                value={register.password}
                type="password"
                placeholder="Password"
                required
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              Phone
            </Form.Label>
            <Col>
              <Form.Control
                name="phone"
                onChange={handleOnChange}
                value={register.phone}
                type="number"
                placeholder="Phone"
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              Address
            </Form.Label>

            <Col>
              <Form.Control
                name="address"
                onChange={handleOnChange}
                value={register.address}
                type="text"
                placeholder="Address"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 formgroup">
            <Form.Label column sm="3">
              Gender
            </Form.Label>
            <Col>
              <InputGroup className="d-flex align-items-center gap-2">
                <InputGroup.Radio
                  aria-label="Radio button for following text input"
                  onChange={handleOnChange}
                  type="radio"
                  value="Male"
                  name="gender"
                />
                Male
              </InputGroup>
            </Col>
            <Col>
              <InputGroup className="d-flex align-items-center gap-2">
                <InputGroup.Radio
                  aria-label="Radio button for following text input"
                  onChange={handleOnChange}
                  type="radio"
                  value="Female"
                  name="gender"
                />
                Female
              </InputGroup>
            </Col>
          </Form.Group>
          <div className="d-grid">
            <Button variant="primary" type="submit">
              Register
            </Button>
          </div>
        </Form>
      </Card>
    </Container>
  )
}

export default RegistrationTable
